export default __webpack_public_path__ + "static/media/643.8e0660a7.png";